import '../../assets/components/Button/button.css';const t = "_button_3k4g2_1", n = "_buttonLink_3k4g2_2", _ = "_primary_3k4g2_8", o = "_secondary_3k4g2_28", s = "_tertiary_3k4g2_51", e = "_expanded_3k4g2_79", c = "_s_3k4g2_28", r = "_m_3k4g2_87", a = "_l_3k4g2_91", k = "_content_3k4g2_99", d = {
  button: t,
  buttonLink: n,
  primary: _,
  secondary: o,
  tertiary: s,
  expanded: e,
  s: c,
  m: r,
  l: a,
  content: k
};
export {
  t as button,
  n as buttonLink,
  k as content,
  d as default,
  e as expanded,
  a as l,
  r as m,
  _ as primary,
  c as s,
  o as secondary,
  s as tertiary
};
